import { render, staticRenderFns } from "./UnreadMessages.vue?vue&type=template&id=06e1d748&scoped=true&"
import script from "./UnreadMessages.vue?vue&type=script&lang=ts&"
export * from "./UnreadMessages.vue?vue&type=script&lang=ts&"
import style0 from "./UnreadMessages.vue?vue&type=style&index=0&id=06e1d748&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e1d748",
  null
  
)

export default component.exports